export const SET_USER = 'SET_USER';
export const SET_HAS_PIN = 'SET_HAS_PIN';
export const SET_ON_BOARDED = 'SET_ON_BOARDED';
export const SET_ON_BOARDING_STEP = 'SET_ON_BOARDING_STEP';
export const UPDATE_TOOLTIP_KEY = 'UPDATE_TOOLTIP_KEY';
